/*POLYFILL IE*/

(function () {
    function CustomEvent ( event, params ) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent( 'CustomEvent' );
        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();

export default class ComponentFactory{

    constructor(jQuery){
        ComponentFactory.classes = [];
        ComponentFactory.$ = jQuery;
        ComponentFactory.breakpoints = [
            {breakpoint:420,    name:'mobile'},
            {breakpoint:720,    name:'tablet'},
            {breakpoint:960,    name:'laptop'},
            {breakpoint:1024,   name:'desktop'},
            {breakpoint:1140,   name:'desktop-xl'}
        ]

        ComponentFactory.currentBreakpoint = null;
        ComponentFactory.calculateBreakpoint();
        ComponentFactory.$(window).resize(function(){
            ComponentFactory.calculateBreakpoint();
        });


    }

    static calculateBreakpoint(){
        var breakpointName = ComponentFactory.breakpoints[0].name;
        ComponentFactory.breakpoints.forEach(function(breakpoint) {
            if (window.innerWidth > breakpoint.breakpoint){
                breakpointName = breakpoint.name;
            }
        });
        if (breakpointName != ComponentFactory.currentBreakpoint){
            ComponentFactory.currentBreakpoint = breakpointName;
            var event = new CustomEvent('breakpoint', { 'detail': breakpointName });
            window.dispatchEvent(event);
        }
    }

    static register(className, classObject){


        ComponentFactory.classes[className] = classObject;
        if (ComponentFactory.$('[data-component="'+className+'"]').length > 0){
            var obj = new classObject(ComponentFactory.$);
            ComponentFactory.$('[data-component="'+className+'"]').each(function(index, element){
                obj.init(index, element);
                obj.resize(index, element);
                obj.scroll(index, element);
                obj.breakpoint(index, element, ComponentFactory.currentBreakpoint)
                ComponentFactory.$(window).resize(function(){
                    try{
                        obj.resize(index, element);
                    }catch (e){
                        //console.log(e);
                    }

                    obj.scroll(index, element);
                });
                ComponentFactory.$(window).on('scroll',function(){
                    obj.scroll(index, element);
                });
                ComponentFactory.$(window).on('load',function(){
                    try{
                        obj.resize(index, element);
                    }catch (e){
                        //console.log(e);
                    }
                    obj.scroll(index, element);
                });



                window.addEventListener('breakpoint', function (e) {
                    obj.breakpoint(index, element, ComponentFactory.currentBreakpoint);
                }, false);
            });
        }
    }
}
